import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { BeautifyDisplayStringPipe } from 'src/app/pipes/beautify-display-string/beautify-display-string.pipe';

@Component({
  selector: 'app-multiple-tags',
  templateUrl: './multiple-tags.component.html',
  styleUrls: ['./multiple-tags.component.scss'],
})
export class MultipleTagsComponent implements OnChanges {
  @Input() public tags = '';

  public firstTag = '';
  public remainingCount = 0;
  public remainingTagsTooltip = '';

  private readonly _beautifyDisplayStringPipe = new BeautifyDisplayStringPipe();

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['tags']) {
      this.computeTagsShown(this.tags);
    }
  }

  private computeTagsShown(tags: string): void {
    if (!tags) {
      this.firstTag = '';
      this.remainingCount = 0;
      this.remainingTagsTooltip = '';
      return;
    }

    const splittedTags = tags.split(',').map((tag) => tag.trim());
    this.firstTag = splittedTags[0];
    this.remainingCount = splittedTags.length - 1;

    if (this.remainingCount > 0) {
      this.remainingTagsTooltip = splittedTags
        .slice(1)
        .map((tag) => this._beautifyDisplayStringPipe.transform(tag))
        .join(', ');
    } else {
      this.remainingTagsTooltip = '';
    }
  }
}
